import queries from './query/walkthrough';
import mutations from './mutation/walkthrough';
import fragments from './fragment/walkthrough';

export const WalkthroughSchema = {
  queries,
  mutations,
  fragments,
};
